import { useLocale } from "../lib/i18n";

interface UpdateToastProps {
  show: boolean;
  onRefresh: () => void;
}

export function UpdateToast({ show, onRefresh }: UpdateToastProps) {
  const { t } = useLocale();

  if (!show) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 mx-auto max-w-[400px] bg-zinc-800 text-white rounded-xl px-4 py-3 flex items-center justify-between shadow-lg">
      <span className="text-sm">{t("update.available")}</span>
      <button
        onClick={onRefresh}
        className="bg-indigo-500 text-white text-sm font-semibold px-4 py-1.5 rounded-lg"
      >
        {t("update.refresh")}
      </button>
    </div>
  );
}
